import type { GetStaticProps } from 'next';
import { Microsites } from 'constants/constants';
import { getRankingStaticProps } from '@/main/lib/utils/miscUtils/getRankingStaticProps';
import RankingFranchiseNextPage, { getStaticPaths } from 'src/pages/ranking/[franchiseSlug]';

export default RankingFranchiseNextPage;

export const getStaticProps: GetStaticProps = async (context) => {
  return getRankingStaticProps(context, { platformCD: Microsites.Asia });
};

export { getStaticPaths };
